// Éthique et chic by Manon — small JS helpers
// Update cart count badge on add-to-cart (Shopify ajax)
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('form[action*="/cart/add"]')) return;
  // Let default behavior happen for now (Shopify redirects to cart page).
});

// Mobile menu toggle
const burger = document.getElementById('MenuToggle');
const mobileMenu = document.getElementById('MobileMenu');
if (burger && mobileMenu) {
  burger.addEventListener('click', () => {
    const open = burger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    burger.setAttribute('aria-expanded', open);
  });
}

// Product type filter pills
const typeFilter = document.getElementById('TypeFilter');
if (typeFilter) {
  typeFilter.addEventListener('click', (e) => {
    const pill = e.target.closest('.type-pill');
    if (!pill) return;
    typeFilter.querySelectorAll('.type-pill').forEach(p => p.classList.remove('active'));
    pill.classList.add('active');
    const type = pill.dataset.type;
    document.querySelectorAll('.grille-produits .produit').forEach(p => {
      p.style.display = (type === 'all' || p.dataset.productType === type) ? '' : 'none';
    });
  });
}

// Collection filter dropdowns
document.querySelectorAll('.filter-toggle').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.filter-group');
    const wasOpen = group.classList.contains('open');
    document.querySelectorAll('.filter-group.open').forEach(g => {
      g.classList.remove('open');
      g.querySelector('.filter-toggle').setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      group.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});
document.addEventListener('click', (e) => {
  if (!e.target.closest('.filter-group')) {
    document.querySelectorAll('.filter-group.open').forEach(g => {
      g.classList.remove('open');
      g.querySelector('.filter-toggle').setAttribute('aria-expanded', 'false');
    });
  }
});
